/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OfferProductBattery } from '../models/OfferProductBattery';
import type { PaginatedOfferProductBatteryList } from '../models/PaginatedOfferProductBatteryList';
import type { PatchedOfferProductBattery } from '../models/PatchedOfferProductBattery';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OffersProductBatteriesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedOfferProductBatteryList
     * @throws ApiError
     */
    public offersProductBatteriesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedOfferProductBatteryList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-batteries/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns OfferProductBattery
     * @throws ApiError
     */
    public offersProductBatteriesCreate({
        requestBody,
    }: {
        requestBody: OfferProductBattery,
    }): CancelablePromise<OfferProductBattery> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/offers-product-batteries/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductBattery
     * @throws ApiError
     */
    public offersProductBatteriesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product battery.
         */
        id: number,
    }): CancelablePromise<OfferProductBattery> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/offers-product-batteries/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns OfferProductBattery
     * @throws ApiError
     */
    public offersProductBatteriesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product battery.
         */
        id: number,
        requestBody: OfferProductBattery,
    }): CancelablePromise<OfferProductBattery> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/offers-product-batteries/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns OfferProductBattery
     * @throws ApiError
     */
    public offersProductBatteriesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this offer product battery.
         */
        id: number,
        requestBody?: PatchedOfferProductBattery,
    }): CancelablePromise<OfferProductBattery> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/offers-product-batteries/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public offersProductBatteriesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this offer product battery.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/offers-product-batteries/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
